// extracted by css-extract-rspack-plugin
export default {"main":"lhBdbEnlNMwVyUlL","message":"wY7bkLFN_AdKkDqe"};